module.exports = __webpack_public_path__ + "static/01-ac0bbfd8860450bc1eff8a67d5151ab9.jpg";